import { SnackbarProps } from '../types/snackbar';

type ResponseHandlerProps = Readonly<{
	result: boolean;
	toastMessages: Readonly<{
		success?: string;
		error: string;
	}>;
	errorMessage?: string | null;
	openSnackbar: (props: Partial<SnackbarProps>) => void;
	callback?: () => void;
	setSentryMessage?: () => void;
}>;

export const mutationResponseHandler = ({
	result,
	toastMessages: { success, error },
	errorMessage,
	callback,
	openSnackbar,
	setSentryMessage,
}: ResponseHandlerProps): void => {
	if (!result) {
		openSnackbar({
			open: true,
			message: error,
			variant: 'alert',
			alert: {
				color: 'error',
			},
			close: true,
		});
		errorMessage && console.error(errorMessage);

		errorMessage && setSentryMessage?.();

		return;
	}
	if (success != null) {
		openSnackbar({
			open: true,
			message: success,
			variant: 'alert',
			alert: {
				color: 'success',
			},
			close: true,
		});
	}
	if (callback) {
		callback();
	}
};
